import { defineMessages } from "react-intl";

export const messages = defineMessages({
  toolbarButonLabel: {
    id: "Q2us5X",
    defaultMessage: "Dry run",
    description: "Dry run icon label",
  },
});
